module.exports = __webpack_public_path__ + "static/media/crocodile(16).c39f3224.PNG";